
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/accessibility-checklist-to-modify-home",
      function () {
        return require("private-next-pages/articles/accessibility-checklist-to-modify-home.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/accessibility-checklist-to-modify-home"])
      });
    }
  